import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { MStaticClient, MStaticInter } from '@argalis-apps/models';
import { AccountConfigService } from '../../../../services/account-config/account-config.service';

@Component({
  selector: 'argalis-apps-static-session-card',
  templateUrl: './session-card.component.html',
  styleUrls: ['./session-card.component.scss']
})
export class SessionCardComponent implements OnInit {
  @HostBinding('class') themeFlag: string;

  @Input('sessionData')
  set _sessionData(value: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo) {
    this.sessionData = value;
  }
  @Input('indicator')
  set _indicator(value: boolean) {
    this.indicator = value;
  }
  public sessionData: MStaticClient.IStaticClientInfo | MStaticInter.IStaticInterInfo;
  public indicator: boolean;
  public headerBackground = 'uk-background-muted';
  public headerColor = 'no-style-applied';
  public bodyBackground = 'no-style-applied';
  public bodyColor = 'no-style-applied';

  constructor(private accountConfigService: AccountConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.accountConfigService.themingClassName}`;
  }
}
